import * as z from "zod";
import { enum as zodEnum } from "zod";

const OrderItemUpdateSchema = z.object({
  variantId: z.string(),
  quantity: z.number().min(0),
  action: zodEnum(["add", "remove"]),
});

export const ConfirmUpdateOrderSchema = z.object({
  items: z.array(OrderItemUpdateSchema),
  orderId: z.string(),
});
export type ConfirmUpdateOrder = z.infer<typeof ConfirmUpdateOrderSchema>;
